function numberValue(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

export function buildPracticeBossSummaries({ bosses = [], practiceRecords = [], actualRecords = [] } = {}) {
  const practiceCountByBoss = new Map();
  const actualCountByBoss = new Map();
  const actualDamageByBoss = new Map();

  for (const record of Array.isArray(practiceRecords) ? practiceRecords : []) {
    const bossNo = numberValue(record?.bossNo ?? record?.boss_no);
    if (!bossNo) continue;
    practiceCountByBoss.set(bossNo, (practiceCountByBoss.get(bossNo) || 0) + 1);
  }

  for (const record of Array.isArray(actualRecords) ? actualRecords : []) {
    const bossNo = numberValue(record?.bossNo ?? record?.boss_no);
    if (!bossNo) continue;
    actualCountByBoss.set(bossNo, (actualCountByBoss.get(bossNo) || 0) + 1);
    actualDamageByBoss.set(bossNo, (actualDamageByBoss.get(bossNo) || 0) + numberValue(record?.damageEok ?? record?.damage_eok));
  }

  return (Array.isArray(bosses) ? bosses : []).map((boss) => {
    const bossNo = numberValue(boss?.bossNo ?? boss?.boss_no);
    return {
      ...boss,
      bossNo,
      practiceCount: practiceCountByBoss.get(bossNo) || 0,
      actualCount: actualCountByBoss.get(bossNo) || 0,
      actualDamageEok: actualDamageByBoss.get(bossNo) || 0,
    };
  });
}

export function countAppliedPracticeSlots(slots = []) {
  return (Array.isArray(slots) ? slots : []).filter((slot) => slot?.source === 'real_applied').length;
}
